import { Link, useLocation } from "react-router-dom";
import { isaddQuizSelected, isQuizSelected } from "utils/checkRouter";
import { useNavigate } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import { MainContext } from "utils/context";
import { useContext, useState, useEffect } from "react";
import { signOutUser, fetchTabsFromDatabase } from "utils/firebaseFunction";
import { FaChevronDown } from "react-icons/fa";

export default function MobileMenu({ closeFn = () => {} }) {
  const { user, loading, isAdmin, selectedTab, setSelectedTab } = useContext(MainContext);
  const navigate = useNavigate();
  const loc = useLocation();
  const userId = user?.uid;
  
  const [tabs, setTabs] = useState([]);
  const [error, setError] = useState("");

  // جلب التصنيفات عند تحميل المكون
  useEffect(() => {
    const fetchTabs = async () => {
      try {
        const fetchedTabs = await fetchTabsFromDatabase();
        setTabs(fetchedTabs);
      } catch (error) {
        console.error("Error fetching tabs:", error);
        setError("Failed to load categories");
      }
    };

    fetchTabs();
  }, []);

  const signOut = async () => {
    try {
      await signOutUser();
      window.location.reload();
    } catch (error) {
      setError("Failed to sign out");
    }
  };

  return (
    <div className="mobile-menu">
      <div className="mobile-menu__content">
        {/* إظهار السيلكت فقط في الصفحة الرئيسية */}
       

        <Link
          to="/"
          onClick={closeFn}
          className={`mobile-menu__content__item 
            ${isQuizSelected(loc.pathname) && "mobile-menu__content__item--selected"}`}
        >
          Quiz
        </Link>

        {isAdmin && (
          <Link
            onClick={closeFn}
            to="/addQuiz"
            className={`mobile-menu__content__item 
              ${isaddQuizSelected(loc.pathname) && "mobile-menu__content__item--selected"}`}
          >
            Add Quiz
          </Link>
        )}

        {isAdmin && userId === "JuAxp52a7uMSF7vrzwxKVpIN6Nw2" && (
          <Link
            onClick={closeFn}
            to="/admin"
            className={`mobile-menu__content__item 
              ${loc.pathname === "/admin" && "mobile-menu__content__item--selected"}`}
          >
            Admin
          </Link>
        )}

        {loading ? (
          <TailSpin
            visible={true}
            height="30"
            width="30"
            color="#3b4142"
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
          />
        ) : user ? (
          <button
            onClick={() => {
              signOut();
              closeFn();
            }}
            className="mobile-menu__content__btn navbar__right-side__btn Btn"
          >
            Sign Out
          </button>
        ) : (
          <button
            onClick={() => {
              navigate("/authenticate");
              closeFn();
            }}
            className="mobile-menu__content__btn navbar__right-side__btn Btn"
          >
            Login
          </button>
        )}
 {loc.pathname === "/" && (
          <div className="custom-select">
            <select
              value={selectedTab}
              onChange={(e) => {
                setSelectedTab(e.target.value);
                closeFn();
              }}
              className="select-input"
            >
              <option value="">All Quiz</option>
              {tabs.map((tab, index) => (
                <option key={index} value={tab}>
                  {tab}
                </option>
              ))}
            </select>
            <FaChevronDown className="select-arrow" />
          </div>
        )}
        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
}